/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from 'ethers';
import type { Provider, TransactionRequest } from '@ethersproject/providers';
import type { PromiseOrValue } from '../../common';
import type {
  ShareEscrow,
  ShareEscrowInterface,
} from '../../contracts/ShareEscrow';

const _abi = [
  {
    inputs: [],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    inputs: [],
    name: 'ArgumentLengthMismatch',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidAddress',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidData',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidFee',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidSignature',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'enum Status',
        name: 'got',
        type: 'uint8',
      },
      {
        internalType: 'enum Status',
        name: 'expected',
        type: 'uint8',
      },
    ],
    name: 'InvalidStatus',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidTaskAmount',
    type: 'error',
  },
  {
    inputs: [],
    name: 'NoChange',
    type: 'error',
  },
  {
    inputs: [],
    name: 'OnlyArbitrator',
    type: 'error',
  },
  {
    inputs: [],
    name: 'OnlyReviewerOrContributor',
    type: 'error',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'bytes32',
        name: 'hash',
        type: 'bytes32',
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'signer',
        type: 'address',
      },
    ],
    name: 'ApproveHash',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'taskId',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'address',
        name: '_contributor',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'bytes',
        name: '_offchainDetails',
        type: 'bytes',
      },
    ],
    name: 'AssignTask',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'taskId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'bytes',
        name: 'offchainDetails',
        type: 'bytes',
      },
    ],
    name: 'CancelTask',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'newArbitrator',
        type: 'address',
      },
    ],
    name: 'ChangeArbitrator',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'newShareFee',
        type: 'uint256',
      },
    ],
    name: 'ChangeShareFee',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'newTreasury',
        type: 'address',
      },
    ],
    name: 'ChangeTreasury',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256[]',
        name: 'taskIdList',
        type: 'uint256[]',
      },
      {
        indexed: false,
        internalType: 'bytes[]',
        name: 'offchainDetailsList',
        type: 'bytes[]',
      },
    ],
    name: 'CompleteTasks',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'taskCount',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'reviewer',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'token',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256[]',
        name: 'amountList',
        type: 'uint256[]',
      },
      {
        indexed: false,
        internalType: 'bytes[]',
        name: 'offchainDetailsList',
        type: 'bytes[]',
      },
    ],
    name: 'CreateTasks',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint8',
        name: 'version',
        type: 'uint8',
      },
    ],
    name: 'Initialized',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'OwnershipTransferred',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'taskId',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'sender',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'bytes',
        name: 'offchainDetails',
        type: 'bytes',
      },
    ],
    name: 'RaiseDispute',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'taskId',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'uint8',
        name: 'disputeDecision',
        type: 'uint8',
      },
      {
        indexed: false,
        internalType: 'bytes',
        name: 'offchainDetails',
        type: 'bytes',
      },
    ],
    name: 'ResolveDispute',
    type: 'event',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: '_hash',
        type: 'bytes32',
      },
    ],
    name: 'approveHash',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    name: 'approvedHashes',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'arbitrator',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes',
        name: '_data',
        type: 'bytes',
      },
      {
        internalType: 'bytes',
        name: '_signature',
        type: 'bytes',
      },
    ],
    name: 'assignTask',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes',
        name: '_data',
        type: 'bytes',
      },
      {
        internalType: 'bytes',
        name: '_signature',
        type: 'bytes',
      },
    ],
    name: 'cancelTask',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_newArbitrator',
        type: 'address',
      },
    ],
    name: 'changeArbitrator',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_newShareFee',
        type: 'uint256',
      },
    ],
    name: 'changeShareFee',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_newTreasury',
        type: 'address',
      },
    ],
    name: 'changeTreasury',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes',
        name: '_data',
        type: 'bytes',
      },
      {
        internalType: 'bytes',
        name: '_signature',
        type: 'bytes',
      },
    ],
    name: 'completeTasks',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_token',
        type: 'address',
      },
      {
        internalType: 'uint256[]',
        name: '_amountList',
        type: 'uint256[]',
      },
      {
        internalType: 'bytes[]',
        name: '_offchainDetailsList',
        type: 'bytes[]',
      },
    ],
    name: 'createTasks',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_shareFee',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: '_treasury',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_arbitrator',
        type: 'address',
      },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_taskId',
        type: 'uint256',
      },
      {
        internalType: 'bytes',
        name: '_offchainDetails',
        type: 'bytes',
      },
    ],
    name: 'raiseDispute',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_taskId',
        type: 'uint256',
      },
      {
        internalType: 'uint8',
        name: '_decision',
        type: 'uint8',
      },
      {
        internalType: 'bytes',
        name: '_offchainDetails',
        type: 'bytes',
      },
    ],
    name: 'resolveDispute',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'shareFee',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'taskCount',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'tasks',
    outputs: [
      {
        internalType: 'enum Status',
        name: 'status',
        type: 'uint8',
      },
      {
        internalType: 'address',
        name: 'reviewer',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'token',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'contributor',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'fee',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'treasury',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
];

const _bytecode =
  '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';

type ShareEscrowConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ShareEscrowConstructorParams,
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ShareEscrow__factory extends ContractFactory {
  constructor(...args: ShareEscrowConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> },
  ): Promise<ShareEscrow> {
    return super.deploy(overrides || {}) as Promise<ShareEscrow>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> },
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): ShareEscrow {
    return super.attach(address) as ShareEscrow;
  }
  override connect(signer: Signer): ShareEscrow__factory {
    return super.connect(signer) as ShareEscrow__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ShareEscrowInterface {
    return new utils.Interface(_abi) as ShareEscrowInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider,
  ): ShareEscrow {
    return new Contract(address, _abi, signerOrProvider) as ShareEscrow;
  }
}
